export default __webpack_public_path__ + "static/media/Path 302.093d53bf.svg";